// system/* page translations
const system = {
  management: {
    tabs: {
      general: 'General',
      monitoring: 'Monitoring',
      alarm: 'Notifications',
      security: 'Security',
      dataCollection: 'Data Collection',
      log: 'System Log',
      ip: 'IP Management',
    },
    common: {
      save: 'Save Settings',
      saving: 'Saving...',
      loading: 'Loading...',
      refresh: 'Refresh',
      saveSuccess: 'Settings saved. Reloading the page...',
      saveFailed: 'Failed to save settings.',
      defaultSystemName: 'Injection Integrated Monitoring System',
    },
    general: {
      sectionBasic: 'Basic Information',
      sectionContact: 'Contact Information',
      sectionBranding: 'Branding',
      labels: {
        systemName: 'System Name',
        companyName: 'Company Name',
        companyCode: 'Company Code',
        schemaName: 'Schema Name',
        businessNumber: 'Business Registration No.',
        representativeName: 'Representative',
        contactEmail: 'Email',
        contactPhone: 'Phone',
        address: 'Address',
        logo: 'Logo',
        favicon: 'Favicon',
      },
      placeholders: {
        contactEmail: 'example@company.com',
        contactPhone: '02-1234-5678',
        address: '123 Teheran-ro, Gangnam-gu, Seoul',
      },
      branding: {
        upload: 'Upload',
        change: 'Change',
        delete: 'Delete',
        uploading: 'Uploading...',
        logoAlt: 'Logo preview',
        faviconAlt: 'Favicon preview',
        hint: 'Supported: JPG, PNG, GIF, SVG, ICO (max 5MB)',
        logoUploadComplete: 'Logo uploaded (applies on save)',
        faviconUploadComplete: 'Favicon uploaded (applies on save)',
        uploadFailed: 'Upload failed',
        fileUploadFailed: 'File upload failed.',
      },
    },
    monitoring: {
      sectionDashboard: 'Dashboard Settings',
      labels: {
        refreshInterval: 'Auto-refresh Interval',
        timezone: 'Time Zone',
      },
      refreshOptions: {
        onComplete: 'On data collection complete',
        sec10: '10 seconds',
        sec30: '30 seconds',
        min1: '1 minute',
        min5: '5 minutes',
        min10: '10 minutes',
        disabled: 'Disabled',
      },
      timezones: {
        seoul: 'Korea Standard Time (KST, UTC+9)',
        hochiminh: 'Vietnam Standard Time (ICT, UTC+7)',
        utc: 'Coordinated Universal Time (UTC)',
        tokyo: 'Japan Standard Time (JST, UTC+9)',
        newyork: 'US Eastern (EST/EDT)',
        london: 'UK Standard (GMT/BST)',
      },
    },
    alarm: {
      sectionChannels: 'Notification Channels',
      sectionSound: 'Alarm Sound',
      labels: {
        web: 'Web Top Notification',
        email: 'Email Notification',
        sms: 'SMS Notification',
        push: 'Web Push Notification',
        sound: 'Alarm Sound',
        mute: 'Mute',
      },
      hints: {
        web: 'Show notification messages at the top of the web',
        email: 'Send notifications to registered email (coming soon)',
        sms: 'Send SMS to registered mobile (coming soon)',
        push: 'Send browser push notifications (coming soon)',
        sound: 'Sound played when a new alarm occurs (saved in this browser only)',
        mute: 'When on, alarm sound is not played',
      },
      preview: 'Preview',
      sounds: {
        single: 'Single Beep',
        double: 'Double Beep',
        triple: 'Triple Beep',
        chime: 'Chime',
        siren: 'Siren',
      },
      on: 'ON',
      off: 'OFF',
    },
    security: {
      sectionLogin: 'Login Security',
      labels: {
        maxAttempts: 'Max Login Failures',
        lockDuration: 'Account Lock Duration',
      },
      hints: {
        maxAttempts: 'Account is locked after the configured number of failed logins',
        lockDuration: 'Time until automatic unlock after lock',
      },
      attempts: {
        n3: '3 times',
        n5: '5 times',
        n10: '10 times',
      },
      duration: {
        m5: '5 minutes',
        m10: '10 minutes',
        m30: '30 minutes',
        h1: '1 hour',
        h24: '24 hours',
      },
    },
    dataCollection: {
      sectionStatus: 'ETL Current Status',
      sectionDb: 'Database Connection Status',
      sectionHistory: 'Sync History',
      cards: {
        runState: 'Run State',
        lastRun: 'Last Run',
        lastSuccess: 'Last Success',
        recordsProcessed: 'Records Processed',
      },
      runState: {
        running: 'Running',
        idle: 'Idle',
      },
      db: {
        rawName: 'Raw DB (MariaDB)',
        monitoringName: 'Monitoring DB (PostgreSQL)',
        connected: 'Connected',
        disconnected: 'Disconnected',
        unknown: 'Unknown',
      },
      history: {
        col: {
          time: 'Sync Time',
          status: 'Status',
          records: 'Records',
          tables: 'Target Tables',
          note: 'Note',
        },
        statusSuccess: 'Success',
        statusFailed: 'Failed',
        empty: 'No sync history',
      },
      actions: {
        refresh: 'Refresh',
        manualSync: 'Manual Sync',
        running: 'Running...',
        inProgress: 'Sync in progress',
      },
      messages: {
        syncStarted: 'ETL sync started.',
        syncFailed: 'Failed to start ETL sync.',
      },
      recordsUnit: '{n}',
    },
    log: {
      sectionHistory: 'Login/Logout History',
      filters: {
        all: 'All',
        login: 'Login',
        logout: 'Logout',
        loginFailed: 'Login Failed',
      },
      col: {
        time: 'Time',
        type: 'Type',
        user: 'User',
        email: 'Email',
        ip: 'IP Address',
        note: 'Note',
      },
      empty: 'No login history',
    },
  },
  ip: {
    notReady: {
      title: 'Server feature not available yet',
      body: 'IP access restriction is not implemented on the server yet. This screen cannot save IP addresses or block access.',
      empty: 'No IP addresses registered',
    },
    controls: {
      addBtn: 'Add IP',
    },
    table: {
      ip: 'IP Address',
      description: 'Description',
      access: 'Access Level',
      status: 'Status',
      lastAccess: 'Last Access',
      createdAt: 'Registered',
      createdBy: 'Registered By',
      actions: 'Actions',
    },
  },
};
export default system;
